import {StyleSheet} from 'react-native';
import {Color, ThemeUtils} from "components/src/utils";

export default StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Color.SECONDARY_BG_COLOR,
    },
    dashboardItem: {
        height: ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(30) : ThemeUtils.relativeRealWidth(45),
        width: ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(30) : ThemeUtils.relativeRealWidth(45),
        marginEnd: ThemeUtils.isTablet()?ThemeUtils.relativeRealWidth(2):ThemeUtils.relativeRealWidth(3),
        marginTop: ThemeUtils.isTablet()?ThemeUtils.relativeRealWidth(2):ThemeUtils.relativeRealWidth(3),
        borderRadius: ThemeUtils.relativeRealWidth(1.5),

    },
    imgServices: {
        flex: 1,
        top: 0,
        bottom: 0,
        end: 0,
        start: 0,
        justifyContent: 'flex-end',
        borderRadius: ThemeUtils.relativeRealWidth(1.5),

    },
    lblCont: {
        flex: 1,
        justifyContent: 'flex-end',
        paddingHorizontal: ThemeUtils.relativeRealWidth(2),
        paddingVertical: ThemeUtils.relativeRealHeight(1)
    },
    dashBoardCont: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginStart: ThemeUtils.relativeRealWidth(3)
    },
    overlay:{
        position:'absolute',
        zIndex:100,
        top:0,
        bottom:0,
        end:ThemeUtils.relativeRealWidth(3),
        start:0,
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:Color.TRANSPARENT_BLACK,
    },
    GridImage: {
        borderRadius: ThemeUtils.relativeRealWidth(2.5),
        height: ThemeUtils.responsiveScale(200),
        // width: ThemeUtils.responsiveScale(200),
        borderWidth: 0.5,
        borderColor: Color.PRIMARY_LIGHTER
    },
    header: {
        backgroundColor: Color.PRIMARY,
        shadowColor: Color.BLACK,
        shadowOffset: {
            width: 0,
            height: 0,
        },
        shadowOpacity: 0,
        shadowRadius: 0,
        elevation: 0,
    },
    indicatorCont:{
        backgroundColor:Color.PRIMARY,
        flex:1
    }
})
